<div class="share-dialog">
  <si-generic-dialog [(displayDialog)]="displayDialog"
                     (displayDialogChange)="onVisibleChange($event)"
                     [dialogTitle]="dialogTitle"
                     [isScrollable]="true">
    <div class="d-flex flex-column align-items-center">
      <div class="mb-2" [innerHTML]="'SI_SHARE_DIALOG_URL_TEXT' | translate"></div>
      <div class="share-dialog_url">
        <a href="{{url}}" target="_blank">
          <span>{{url}}</span>
        </a>
      </div>
      <div>
        <qrcode [qrdata]="url" [width]="140" errorCorrectionLevel="M"></qrcode>
      </div>
      <div *ngIf="error" class="mb-2">
        <si-generic-alert [showAlert]="error"
                          styleClass="error"
                          [text]="error"
        ></si-generic-alert>
      </div>
      <div *ngIf="expirationTime">
        <span>{{((expirationTime === 1 ? 'SI_SHARE_DIALOG_EXPIRATION_TIME': 'SI_SHARE_DIALOG_EXPIRATION_TIME_PL') | translate: {time: expirationTime})}}</span>
      </div>
      <div class="share-dialog_pin mb-3">
        <span>{{pin}}</span>
      </div>
    </div>
    <div class="row justify-content-end pasi-gap-v-10">
      <div *ngIf="showCopy" class="col-12 col-sm-6 col-lg-auto">
        <button class="si-button_main w-100"
                translate="SI_COPY_URL"
                type="button"
                (click)="onClickCopy()"
        ></button>
      </div>
      <div *ngIf="showShare" class="col-12 col-sm-6 col-lg-auto">
        <button class="si-button_main w-100"
                translate="SI_SHARE"
                type="button"
                (click)="onClickShare()"
        ></button>
      </div>
    </div>
  </si-generic-dialog>
</div>
